export enum ApiOrgType {
  NONPROFIT = 'NONPROFIT',
  GOVERNMENT = 'GOVERNMENT',
  CORPORATION = 'CORPORATION',
  CONSULTANT = 'CONSULTANT',
  RECRUITER = 'RECRUITER',
  COMMUNITY = 'COMMUNITY',
}
